import React from 'react'
import TodoItem from './TodoItem'
 

export default function TodoList(props){

    return (
    <table>
            {props.todos.map((todo,index) => {
                return <TodoItem
                    todo={todo}
                    key={todo._id}
                    index={index}
                    onChange={props.onToggle}
                    onChange2={props.Priority}
                    onChange3={props.Date}
                    onChange4={props.Text}
                />
            })}
    </table>
    )
}

